import getJSONP, { HOST } from "./request";
import { getParam } from "@utils";

export const name = getParam("name") || "mcdofficial";
export const preview = getParam("preview") || 0;

export const get_new_template_api = (params: {
  name: string;
  preview: string;
}) => {
  return getJSONP(
    `https://www.${HOST}/website/getWebsiteConfig?name=${params.name}&preview=${params.preview}`
  );
};

export const get_news_api = (params: {
  name: string;
  language: string;
  page?: number;
  pageSize?: number;
  type: "strategy" | "notice" | "activity";
}) => {
  return getJSONP(
    `//www.${HOST}/website/getOfficialWebsiteArticleList?name=${
      params.name
    }&language=${params.language || ""}&type=${params.type || ""}`
  );
};

export const get_news_detail_api = (params: {
  id: number;
  name: string;
  language: string;
}) => {
  return getJSONP(
    `//www.${HOST}/website/getWebsiteArticleById?id=${params.id}&name=${params.name}&language=${params.language}`
  );
};
